// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__EPbdA","loaderOuter":"PageOverlayLoader_loaderOuter__3HCCC"};